import { Record as record } from 'immutable';

import { construct, fields, resolve } from '../../helpers/LinkMapper';

const defaults = {
    billingAddress: null,
    callId: null,
    cardArtFileName: null,
    cardBrand: null,
    cardHolderName: null,
    cardType: null,
    deliveryAddress: null,
    emailAddress: null,
    expirationDate: null,
    expired: true,
    lastFourDigits: null
};

class VisaCheckoutCardInfoResponse extends record(defaults) {
    static fromJSON (json = {}) {
        return construct(VisaCheckoutCardInfoResponse, json, {
            billingAddress: resolve(json.address).with(data => data),
            callId: fields.string,
            cardArtFileName: fields.string,
            cardBrand: fields.string,
            cardHolderName: fields.string,
            cardType: fields.string,
            deliveryAddress: resolve(json.shippingAddress).with(data => data),
            emailAddress: fields.string,
            expirationDate: fields.string,
            expired: fields.bool,
            lastFourDigits: fields.string
        });
    }

    isValid () {
        return this.callId && !this.expired;
    }
}

export default VisaCheckoutCardInfoResponse;



// WEBPACK FOOTER //
// ./src/records/payment/VisaCheckoutCardInfoResponse.js